import Vue from 'vue';
import dayjs from 'dayjs';

const formatHour = value => (value ? dayjs(value).format('HH:mm') : '');

Vue.filter('formatHour', formatHour);
